/**
 * src/components/shared/Button.jsx
 *
 * The one button (docs/ui-component-map-and-governance.md §3.1/§3.3). It
 * renders the `.btn` classes from globals.css, so size, weight and colour are
 * the same on every screen (finding C11).
 *
 * `variant` names the button's job (DS-B-003):
 *   primary  the one primary action of a surface
 *   ghost    every secondary action, including Cancel
 *   danger   a destructive action
 * `size="sm"` is for dense rows and toolbars. There is no `style` or
 * `className` pass-through: a screen that needs a different button needs a
 * registry change, not a local override.
 */

const VARIANTS = new Set(['primary', 'ghost', 'danger']);

/**
 * @param {object} props
 * @param {'primary'|'ghost'|'danger'} [props.variant]
 * @param {'md'|'sm'} [props.size]
 * @param {'button'|'submit'} [props.type]
 * @param {React.ReactNode} props.children
 */
export default function Button({
  variant = 'ghost',
  size = 'md',
  type = 'button',
  children,
  style: _style,
  className: _className,
  ...rest
}) {
  const v = VARIANTS.has(variant) ? variant : 'ghost';
  return (
    <button type={type} className={`btn btn-${v}${size === 'sm' ? ' btn-sm' : ''}`} {...rest}>
      {children}
    </button>
  );
}
